export const STORE_ORDER_TYPE_LIST = "STORE_ORDER_TYPE_LIST";
export const STORE_CASE_TYPE_LIST = "STORE_CASE_TYPE_LIST";
export const CLEAR_LIST = "CLEAR_LIST";
